const arrayToObject = (array, key) => array.reduce((acc, cur) => ({...acc, [cur[key]]: cur}) , {});

export default arrayToObject;